__webpack_require__.p = "/reports-loading-indicator-bug/referrals-hub/";